import { Grid, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import _ from "lodash";
import moment from "moment";
import React from "react";
import { SIDE_PADDING } from "../../app/theme/muiTheme";

const useStyles = makeStyles((theme) => ({
  root: {
    borderWidth: 1,
    borderStyle: "solid",
    borderRadius: 5,
    paddingBottom: "2%",
    borderColor: theme.palette.secondary.light,
    overflow: "hidden",
  },
  datetxt: {
    paddingLeft: SIDE_PADDING,
    paddingRight: SIDE_PADDING,
  },
  desctxt: {
    paddingLeft: SIDE_PADDING,
    paddingRight: SIDE_PADDING,
    fontSize: 30,
    [theme.breakpoints.down("md")]: {
      fontSize: 20,
    },
  },
  image: {
    width: "100%",
  },
}));

const DebateCard = (props) => {
  const classes = useStyles();

  return (
    <Grid
      item
      xs={12}
      md={6}
      style={{
        padding: "2%",
      }}
    >
      <div className={classes.root}>
        <iframe
          width="100%"
          height={"400vw"}
          src={_.get(props, ["data", "url"])}
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
        <br />
        <br />
        <Typography className={classes.datetxt}>
          {moment(_.get(props, ["data", "updatedAt"])).format("DD/MM/YYYY")}
        </Typography>
        <br />
        <Typography className={classes.desctxt}>
          {_.get(props, ["data", "title"])}
        </Typography>
      </div>
    </Grid>
  );
};

export default DebateCard;
